module.exports = __webpack_public_path__ + "img/c34e1a14-2473-4846-b2b8-c6bccd736bb0.0f1988d4.png";